import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import Header from "./Header";
import AccountNav from "./AccountNav";
import LoadingData from "../../utilities/LoadingData";
import { records } from "../../../services/writerCourse";
import NoData from "../../utilities/NoData";

class Courses extends Component {
    
	state = {
		item: {},
		freecourse : true,
		coursepurchased : false,
		loading: true
	};

	handleMenu = field => {
		if(field == 'freecourse')
		{
			this.getCourse('free');
			this.setState({freecourse : true, coursepurchased : false});
		}
		if(field == 'coursepurchased')
		{
			this.getCourse('paid');
			this.setState({freecourse : false, coursepurchased : true});
		}
	}

	getCourse(type)
	{
		//console.log(type);
		this.setState({			
			loading: true
        });       
        records(type).then(response => {
			this.setState({
				items: response.data,			
				loading: false
			});
		});
	}

    componentDidMount() {
       this.getCourse('free');
    }
	
	render() {
        return (
            <Fragment>
                <Header></Header>
                <div>
				    {/* <section className="dashboard-nav">
		                <div className="container">
		            	    <div className="head">
		            		    <h1>Courses</h1>
		            		</div>		            		
		            		<AccountNav></AccountNav>
		            	</div>
		            </section> */}
					<section className="jobsDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 mt-4">
					<div className="container writer-container">
					    <div className="row">
					        <div className="col-md-3">
							    <div className="card custom">
							        <div className="card-header">
							    	    Courses
							        </div>
                                    <div className="card-body">									
							    	    <nav className="custom-sidenav" id="myScrollspy">
                                            <ul className="list-group">
                                            	<li className={this.state.freecourse ? `active`: null}><a to="#" onClick={() => this.handleMenu('freecourse')}>Free Course</a></li>
                                            	<li className={this.state.coursepurchased ? `active`: null}><a to="#" onClick={() => this.handleMenu('coursepurchased')}>Purchased Courses</a></li>
                                            </ul>
                                        </nav>
							    	</div>
							    </div>	
							</div>
					        <div className="col-md-9 mt-md-0 mt-4">
					        	<div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h1 className="header-title">
                                                    {this.state.freecourse ? 'Free Course' : 'Purchased Courses' }
                                                </h1>
                                            </div>
                                            <div className="col-auto"></div>
                                        </div>
                                    </div>
                                </div>
								<div className="card">
								    <div className="table-responsive">
									{this.state.loading === true ? (
                                            <LoadingData></LoadingData>
                                        ) : this.state.items.length === 0 ? (
											<NoData></NoData>
											) : (
                                        <table className="table table-sm table-nowrap card-table">
                                            <thead>
                                                <tr>
                                                    <th className="w-40">Course Name</th>
													<th>Course duration</th>
													<th>Complete %</th>
													<th className="text-right">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list">
											{this.state.items.map((item, index) => {
												return (
                                                <tr key={index}>
												    <td className="w-40 align-middle">
													    <div className="row align-items-center">
														    <div className="col-4">
															    <img src={`/data/course/${item.course.image}`}  alt="course-image"/>
															</div>
															<div className="col-8">
																{item.course.title}
															</div>
														</div>
													</td>
													<td className="align-middle">{item.course.duration}</td>
													<td className="align-middle">{item.completion}%</td>
													<td className="align-middle text-right">
													    <a                                                                   
                                                            type="button"
															className="btn btn-primary btn-sm ml-2"
															href={`/course/${item.course.id}/${item.course.slug}`}
															target="_blank"
                                                        >
                                                            View Course
                                                        </a>
													</td>
												</tr>
												);
											})}	
                                            </tbody>
                                        </table>
										 )}
									</div>
                                </div>
                            </div>
					    </div>
					</div>
				</section>
				</div>
            </Fragment>
        );
    }
}

Courses.contextType = AppContext;
export default Courses;



// WEBPACK FOOTER //
// ./src/components/writer/account/Courses.js